<template>
  <!-- LINK -->
  <a
    v-if="isDownload"
    :href="to"
    download
    v-bind="$attrs"
    :class="variantStyle"
    :target="target ? target : $isExternalUrl(to) ? '_blank' : '_self'"
    class="
      relative flex w-fit items-center transition duration-200 ease-in
      hover-focus:duration-300 hover-focus:ease-out
      print:hidden
    "
    @click="trackDownload"
  >
    <!-- DOWNLOAD -->
    <slot />

    <span
      v-if="$slots.icon"
      class="relative ml-[0.75em] w-[1.5em] shrink-0"
    >
      <span class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
        <slot name="icon" />
      </span>
    </span>

    <IconExternalLink
      v-if="showExternalIcon && $isExternalUrl(to)"
      class="ml-[0.75em] w-[1em] shrink-0"
    />
  </a>

  <NuxtLink
    v-else-if="to"
    :to="to"
    v-bind="$attrs"
    :class="variantStyle"
    :target="target ? target : $isExternalUrl(to) ? '_blank' : '_self'"
    class="
      relative flex w-fit items-center transition duration-200 ease-in
      hover-focus:duration-300 hover-focus:ease-out
      print:hidden
    "
  >
    <!-- NUXTLINK -->
    <slot />

    <span
      v-if="$slots.icon"
      class="relative ml-[0.75em] w-[1.5em] shrink-0"
    >
      <span class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
        <slot name="icon" />
      </span>
    </span>

    <IconExternalLink
      v-if="showExternalIcon && $isExternalUrl(to)"
      class="ml-[0.75em] w-[1em] shrink-0"
    />
  </NuxtLink>

  <button
    v-else
    type="button"
    :class="variantStyle"
    v-bind="$attrs"
  >
    <!-- BUTTON -->
    <slot />

    <span v-if="$slots.icon" class="ml-[0.75em] shrink-0">
      <slot name="icon" />
    </span>
  </button>
</template>

<script setup lang="ts">
const { trackEvent } = useFathom()

const props = defineProps({
  to: {
    type: [String, Object],
    default: null,
  },

  target: {
    type: String,
    default: null,
  },

  variant: {
    type: String,
    default: '',
  },

  showExternalIcon: {
    type: Boolean,
    default: false,
  },
})

const isDownload = computed(() => {
  return typeof props.to === 'string' && props.to?.startsWith('https://s3.eu-central-2.wasabisys.com')
})

const variantStyle = computed(() => {
  const classes = []

  if (props.variant === 'primary') {
    classes.push(`
      rounded-bl-xl border p-2 text-xs
      bg-red-500 border-red-500 text-white
      hover-focus:bg-transparent hover-focus:text-red-500
    `)
  }

  if (props.variant === 'secondary') {
    classes.push(`
      rounded-bl-xl border p-2 text-xs
      bg-white text-red-500 border-white
      hover-focus:bg-transparent hover-focus:text-white
    `)
  }

  if (props.variant === 'white') {
    classes.push(`
      rounded-bl-xl border p-2 text-base leading-none
      bg-white text-red-500 border-white
      hover-focus:text-black hover-focus:bg-gray-200 hover-focus:border-gray-200
    `)
  }

  return classes
})

function trackDownload() {
  trackEvent('download')
  trackEvent(`file downloaded: ${props.to}`)
}
</script>
